import { registerImages, Source } from '@bonanza-social/moonlight';
import images from './images';

declare global {
  interface RegisteredImages {
    communityJackpot: Record<keyof typeof images, Source>;
  }
}

registerImages('communityJackpot', images);
